export default __webpack_public_path__ + "static/media/phone.4ef73168.svg";